import React from "react";
import AuthImage from "@/components/AuthImage";

function Detail({ label, value, full }) {
  return (
    <div className={full ? "col-span-2" : ""}>
      <div className="label-elegant mb-1">{label}</div>
      <div className="text-[#1A1A1A]">{value || <span className="text-[#a8a8a8]">—</span>}</div>
    </div>
  );
}

/** Specs + reference photos for a single order. Read-only. */
export default function OrderSpecs({ order }) {
  return (
    <section className="surface-card p-8 lg:col-span-2">
      <div className="overline">Specifications</div>
      <h2 className="font-serif text-2xl mt-1 text-[#1A1A1A]">Order Details</h2>
      {order.club_name && (
        <div className="mt-4 inline-flex items-center gap-3 border border-[#B59A5A] bg-[#FBF6E8] px-3 py-2">
          <span className="text-[0.65rem] tracking-[0.22em] uppercase font-semibold text-[#8a6f33]">For</span>
          <span className="font-serif text-base text-[#1A1A1A]">{order.club_name}</span>
          <span className="text-[#B59A5A]">·</span>
          <span className="text-xs font-mono text-[#1A422D]">Member #{order.club_member_number}</span>
        </div>
      )}
      <div className="mt-6 grid grid-cols-2 gap-x-6 gap-y-4 text-sm">
        <Detail label="Item Name" value={order.item_name} full />
        <Detail label="Brand" value={order.brand} />
        <Detail label="Category" value={order.category} />
        <Detail label="Subcategory" value={order.subcategory} />
        <Detail label="Description" value={order.description} full />
        <Detail label="Color" value={order.color} />
        <Detail label="Quantity" value={order.quantity} />
        <Detail label="Size" value={order.size} />
        <Detail label="Logo" value={order.logo_preference} />
        <Detail label="Logo Location" value={order.logo_location} />
        <Detail
          label="Where Seen"
          value={
            order.where_seen
              ? order.where_seen === "Other"
                ? (order.where_seen_other || "Other")
                : order.where_seen
              : null
          }
          full
        />
        <Detail label="Notes" value={order.notes} full />
      </div>

      {order.photos?.length > 0 && (
        <div className="mt-8">
          <div className="overline">Photos & Video</div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 mt-3">
            {order.photos.map((p) => {
              const isVideo = (p.content_type || "").startsWith("video/");
              return (
                <div key={p.photo_id} className="border border-[#E5E3D8] aspect-square bg-white overflow-hidden">
                  {isVideo ? (
                    <div className="w-full h-full bg-[#1A422D] text-[#F9F8F4] flex flex-col items-center justify-center text-center p-3">
                      <div className="text-3xl">▶</div>
                      <div className="overline mt-1" style={{ color: "#D9C68A" }}>Video</div>
                    </div>
                  ) : (
                    <AuthImage photoId={p.photo_id} alt="" className="w-full h-full object-cover" />
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}
    </section>
  );
}
